import Shimmer from '@components/core/Shimmer/Shimmer';
import ShimmerWrapper from '@components/core/Shimmer/ShimmerWrapper';

const JobAdPreviewContainerSkeleton = () => {
    return (<ShimmerWrapper spacing={32} direction='column' align='flex-start'>
        <ShimmerWrapper spacing={16} direction='row' align='flex-start' justify='space-between'>
            <Shimmer width="30%" height={60} radius={6} /> 
            <Shimmer width="30%" height={60} radius={6} /> 
        </ShimmerWrapper>
        <ShimmerWrapper spacing={32} direction='column' align='flex-start' justify='space-between'>
            <Shimmer width="80%" height={100} radius={6} /> 
            <Shimmer width="40%" height={20} radius={6} /> 
            <Shimmer width="40%" height={20} radius={6} /> 
            <Shimmer width="40%" height={20} radius={6} />
        </ShimmerWrapper>
        <ShimmerWrapper spacing={32} direction='column' align='flex-start' justify='space-between'>
            <Shimmer width="80%" height={100} radius={6} /> 
            <Shimmer width="60%" height={20} radius={6} /> 
            <Shimmer width="60%" height={20} radius={6} /> 
        </ShimmerWrapper>
    </ShimmerWrapper>);
};

export default JobAdPreviewContainerSkeleton;